import { useState } from "react";
import type { MosaicNode, MosaicPath } from "react-mosaic-component";
import {
	handleClose,
	resizeWindow,
} from "@/components/widgets/helpers/ButtonsPanel";
import type { ViewId } from "@/shared/types/common";
import type { CreateControls } from "./ToolbarControlItemTypes";

export const createControls: CreateControls = (
	state: MosaicNode<ViewId> | null,
	setState: (layout: MosaicNode<ViewId> | null) => void,
	path: MosaicPath,
) => {
	const [savedState, setSavedState] = useState<MosaicNode<ViewId> | null>(null);
	const [isFocused, setIsFocused] = useState(false);

	const handleFocusClick = () => {
		if (isFocused) {
			setState(savedState);
			setIsFocused(false);
		} else {
			setSavedState(state);
			resizeWindow(state, setState, path, 80);
			setIsFocused(true);
		}
	};

	const handleCloseClick = () => {
		handleClose(
			state,
			(newState) => {
				setState(newState as MosaicNode<ViewId>);
			},
			path,
		);
	};

	return [
		{
			key: "focus",
			label: "Focus",
			imgSrc: "#focus",
			onClick: handleFocusClick,
			alt: "Focus",
		},
		{
			key: "close",
			label: "Close",
			imgSrc: "#close",
			onClick: handleCloseClick,
			alt: "Close",
		},
	];
};
